module.exports = __webpack_public_path__ + "media/images/aloe/icons/demo/elements/cards-e22910ba16e38a8b06dc4ecee1708269.svg";